import { Swiper, SwiperSlide } from "swiper/react";
import ShopVerticalCard from "components/shopCard/shopVerticalCard";
import { IShop } from "interfaces";
import cls from "./visitedShops.module.scss";
import { useTranslation } from "react-i18next";
import { Lazy } from "swiper";

type Props = {
  data?: IShop[];
};

export default function VisitedShops({ data }: Props) {
  const { t } = useTranslation();
  return (
    <div className={cls.container}>
      <h1 className={cls.title}>{t("recently.visited")}</h1>
      <Swiper slidesPerView="auto" spaceBetween={20} lazy modules={[Lazy]}>
        {data?.map((shop: IShop) => (
          <SwiperSlide key={shop.id} className={cls.swiperSlide}>
            <ShopVerticalCard data={shop} />
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
}
